import { type VoidFunctionComponent } from 'react';

import FilterCard from '../../../../../../../../generic/Filter/FilterCard';
import type { TeamSelectOption } from '../../../../../../../../shared/teams/hooks/useTeamsSelectOptions';

type Props = {
  isLoading: boolean;
  teamOptions: TeamSelectOption[];
  selectedTeamOptions: TeamSelectOption[];
  onTeamsSelected: (selected: TeamSelectOption[]) => void;
};

const ProjectTeamsFilter: VoidFunctionComponent<Props> = ({
  isLoading,
  teamOptions,
  selectedTeamOptions,
  onTeamsSelected,
}) => {
  //  This hook will fetch the teams on mount,
  //  convert them into select options, manage the selected teams,
  //  and also update the teamId filter when the selected teams change
  return (
    <FilterCard.MultiSelect
      label="Team"
      placeholder={isLoading ? 'Loading...' : 'Select teams...'}
      options={teamOptions}
      values={selectedTeamOptions}
      onChange={onTeamsSelected}
    />
  );
};

export default ProjectTeamsFilter;
